// Tell webpack to include your component specific css
var mms = require("../../jsom/mms");
var utils = require("../../shared/utils");
var $ = require("jquery");

var selectors = {
	buttonContainer: "#OKCancelSection",
	btnPublish: "#btn-breadcrumb-publish",
	termsetId: "#ItemId",
	termsetName: "#ItemName",
	termGroupName: "#ctl00_PlaceHolderMain_groupName",
	leftPanel: "#TmtContentTable .leftarea"
};

var btnHtml = 
	`<input 
		id='btn-breadcrumb-publish'
		style='float:right'
		type="button" value="Publish" 
		class="ms-ButtonHeightWidth" />`


var create = function() {
	var component = {};
	var dao = utils.getRootDao();

	component.publishBreadcrumb = function() {
		// Get the termset id from the DOM
		var termsetId = document.querySelector(selectors.termsetId).innerHTML;
		// Get a flattened list of all the terms
		mms.getTerms(termsetId, SP.ClientContext.get_current())
			// Group the terms
			.then(mms.groupTerms)
			// Save to style library as breadcrumb.json
			.then((breadcrumb) => {
				var fileContents = JSON.stringify(breadcrumb);
				var file = {
					folder: utils.getFolderPath(),
					name: "breadcrumb.txt"
				};
				file.path = file.folder + "/" + file.name;
				
				return dao.web.fileAction(file.path, "checkout")
					.then(() => dao.web.uploadFile(fileContents, file.folder, { name: file.name }))
					.then(() => dao.web.fileAction(file.path, "checkin", { checkInType: 1 }))
					.then(() => console.log(`Successfully updatesd ${file.path}`))
					.catch(() => console.log(arguments))
			});
	};

	component.render = function() {
		var btn = document.querySelector(selectors.btnPublish);
		var $container = $(selectors.buttonContainer);
		var shouldShow = component.shouldShow();

		// If the button is on the page, but shouldn't show
		if (btn && !shouldShow) {
			// Remove the button
			$container[0].removeChild(btn);
		}
		// If the button is not on the page and should show
		else if (!btn && shouldShow && $container.length) {
			// render the button and add a click event
			$container.append(btnHtml);
			$(selectors.btnPublish).on("click", component.publishBreadcrumb);;
		}
	};

	component.bindEvents = function() {
		$(selectors.leftPanel).on("click", component.render);
	};

	component.shouldShow = function() {
		return $(selectors.termsetName).text() === "Breadcrumb"
	} 

	setTimeout(() => {
		component.render();
		component.bindEvents();
	},1)
	return component;
};

module.exports = { create: create };



// WEBPACK FOOTER //
// ./src/scripts/components/breadcrumbPublisher/index.js